<div class="fixed-min-header-height px-4 main-bg-color">


    <ul class="breadcrumbs d-flex pt-5">
        <li>
            <a routerLink="/" title="Home">Home</a>
        </li>
        <li>
            <span> <img src="../../assets/images/seperator-arrow.svg" alt="seperator-arrow" /> </span>
        </li>
        <li>
            <a [routerLink]="['/mycart/']" title="My cart">My Cart</a>
        </li>
        <li>
            <span> <img src="../../assets/images/seperator-arrow.svg" alt="seperator-arrow" /> </span>
        </li>
        <li>
            Review case limit
        </li>
    </ul>

    <a href="javascript:void(0);" [routerLink]="['/mycart/']" title="back" class="back-listing-btn d-none d-lg-block back-cart">
        <svg width="15px" height="16px" viewBox="0 0 15 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>Combined Shape</title>
      <desc>Created with Sketch.</desc>
      <g id="SCREENS" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="210209_shopboss_cart" transform="translate(-1719.000000, -1333.000000)" fill="#D9394C"
          fill-rule="nonzero">
          <path
            d="M1726.46967,1333.46967 L1727.53033,1334.53033 L1721.811,1340.24967 L1734,1340.25 L1734,1341.75 L1721.811,1341.74967 L1727.53033,1347.46967 L1726.46967,1348.53033 L1719.46967,1341.53033 C1719.2034,1341.26406 1719.1792,1340.8474 1719.39705,1340.55379 L1719.46967,1340.46967 L1726.46967,1333.46967 Z"
            id="Combined-Shape"></path>
        </g>
      </g>
    </svg> Back </a>

    <div class="category-title">
        <img class="shadow-cart" src="../../../../assets/images/red-cart.svg" alt=""> <span class="px-2">Category Limits
      In:</span> <span class="text-danger px-4">{{reviewOrderList?.length}} Categories</span>
    </div>

    <div class="category-limit">
        <img src="../../../../assets/images/cart-black.svg" alt=""> Category limits to resolve
    </div>

    <div class="main-box-scrool" *ngIf="reviewOrderList?.length != 0">
        <div class="box-review-main" [ngClass]="(cat?.max_allowed_qty != null && cat?.min_allowed_qty == null && cat.current_cart_qty <= cat.max_allowed_qty) || (cat?.min_allowed_qty != null && cat?.max_allowed_qty == null && cat.current_cart_qty >= cat.min_allowed_qty) || (cat?.min_allowed_qty != null && cat?.max_allowed_qty != null && cat.current_cart_qty >= cat.min_allowed_qty && cat.current_cart_qty <= cat.max_allowed_qty) ? 'green-bg' : 'pink-bg'"
            *ngFor="let cat of reviewOrderList;trackBy: trackByFn">
            <div class="review-header-bar">
                <img src="../../../../assets/images/header-icon-image.svg" alt=""> {{cat.category_name}}
            </div>

            <div class="min-max-review">
                <div class="min-max-review-text">
                    <span *ngIf="cat?.min_allowed_qty != null">Min Limit : {{cat.min_allowed_qty}} Cases</span> <span *ngIf="cat?.max_allowed_qty != null">Max Limit : {{cat.max_allowed_qty}} Cases</span> <span *ngIf="cat?.current_cart_qty">Currently in cart: {{cat.current_cart_qty}} cases</span>
                </div>

                <diV>
                    <Button [ngClass]="(cat?.max_allowed_qty != null && cat.current_cart_qty >= cat.max_allowed_qty) ? 'disable' : ''" (click)="addMoreProductsRedirection(cat)" class="add-more-products">Add more products</Button>
                </diV>
            </div>


            <div class="col-md-12">

                <div class="order-detail-main" *ngFor="let product of cat.items;trackBy: trackByFn">
                    <div class="image-box">
                        <img src="{{imagePath}}{{product?.images[0]}}" alt="">
                    </div>


                    <div class="title-main">
                        <h6>{{product.short_desc}}</h6>
                        <ul class="product-code">
                            <li>{{product.barcode}}</li>
                            <li class="seperator">|</li>
                            <li>{{product.sku}}</li>
                        </ul>
                    </div>

                    <div class="rsp">
                        <div class="small-title">RSP</div>
                        <p> <span class="black-big" *ngIf="product.rsp !== '0.00'">£{{product.rsp}}</span>
                            <span class="font-14" *ngIf="product.rsp == '0.00'">N/A</span>
                            <span class="font-14" *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && (product.sale_unit == 'Kilo' || product.sale_unit == 'Each'))">per 100g</span>
                            <span class="font-14" *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && product.sale_unit.indexOf('C') !== -1)">each</span>
                    </div>

                    <div class="rsp" *ngIf="global_data?.margin_visibility == 1">
                        <div class="small-title">Margin</div>
                        <span class="black-big">{{product.margin}}%</span>
                    </div>
                    <div class="rsp" *ngIf="global_data?.price_visibility == 1">
                        <div class="small-title">Cost</div>
                        <div class="black-big">£{{product.price}}</div>
                    </div>

                    <div class="small-rsp-case">
                        <div class="small-title">Case</div>
                        <div class="black-big">{{product.size_case}}</div>
                    </div>


                    <div class="spinner" id="spinner_{{product.product_id}}">
                        <ngx-number-spinner id="spinerbtn_{{product.product_id}}" [value]="product.item_qty !='' ? toInteger(product.item_qty) : 1" [min]="0" (change)="qytUpdate(product, $event, cat, cartTemplate)" [max]="(cat?.max_allowed_qty != null && cat.current_cart_qty >= cat.max_allowed_qty)? product.item_qty : undefined">
                        </ngx-number-spinner>
                    </div>

                    <div class="small-rsp" *ngIf="global_data?.price_visibility == 1">
                        <div class="black-big">£{{product.row_total}}</div>
                    </div>


                    <div class="canceleed-button">
                        <a href="javascript:void(0);" (click)="removePopup(cartTemplate, cat, product, 'type2');" title="Delete product">
                            <img src="../../../../assets/images/delete-main.svg" alt="delete">
                        </a>
                    </div>


                </div>



            </div>
        </div>
    </div>

    <div class="no-review mt-3 mb-3" *ngIf="reviewOrderList?.length == 0">
        <img src="../../../../assets/images/no-review.svg" alt="">
    </div>

</div>

<div class="bottom-review-main">
    <div class="bottom-review-bar">
        <button [ngClass]="failureCount > 0 ? 'disable' :'' " class="procedd-button" (click)="validate()">Proceed to Order Summary
        </button>
    </div>
</div>

<ng-template #cartTemplate>
    <div class="modal-header border-0 pb-2">
        <h4 class="modal-title">Confirmation!</h4>
        <button type="button" class="close  " *ngIf="removeType == 'type1'" aria-label="Close" (click)="cancleRequest(selectedCategory, removeProduct)">
        <span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
          <g fill="none" fill-rule="evenodd">
            <g stroke="#9B9B9B" stroke-width="1.75">
              <g>
                <g>
                  <path d="M14 0L0 14M0 0L14 14"
                    transform="translate(-1190 -462) translate(695 443) translate(496 20)" />
                </g>
              </g>
            </g>
          </g>
        </svg></span>
    </button>
        <button type="button" class="close" *ngIf="removeType == 'type2'" aria-label="Close" (click)="bsModalRef.hide()">
        <span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <g fill="none" fill-rule="evenodd">
              <g stroke="#9B9B9B" stroke-width="1.75">
                <g>
                  <g>
                    <path d="M14 0L0 14M0 0L14 14"
                      transform="translate(-1190 -462) translate(695 443) translate(496 20)" />
                  </g>
                </g>
              </g>
            </g>
          </svg></span>
      </button>
    </div>
    <div class="modal-body py-0 px-0">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <p>{{removeHeading}}</p>
                </div>
                <div class="button-div text-center mt-3">
                    <button class="common-button mr-3" *ngIf="removeType == 'type2'" (click)="bsModalRef.hide()">Cancel</button>
                    <button class="common-button mr-3" *ngIf="removeType == 'type1'" (click)="cancleRequest(selectedCategory, removeProduct)">Cancel</button>
                    <button class="common-button ghost" (click)="removeItem(selectedCategory, removeProduct)">Confirm</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>